<template>
    <div style="height: 100%">
        <div style="width: 100%">
            <el-row class="filter-bar" ref="filterBar">
                    <el-select size="mini" v-model="formDatas.asId" filterable clearable @change="partserch"
                        placeholder="请选择" style="width: 180px;">
                        <el-option v-for="(item, index) in getAjefShopList_data" :key="index" :label="item.asName"
                            :value="item.asId"></el-option>
                    </el-select>
                    <el-date-picker v-model="formDatas.asrYearMonth" type="month" value-format="yyyyMM"
                        placeholder="归属年月" style="width: 140px" size="mini" clearable @change="partserch">
                    </el-date-picker>
                    <el-select size="mini" v-model="formDatas.asrStatus" clearable @change="partserch" placeholder="请选择"
                        style="width: 130px">
                        <el-option label="创建" :value="1"></el-option>
                        <el-option label="待商户上传" :value="2"></el-option>
                        <el-option label="商户已上传" :value="3"></el-option>
                        <el-option label="待商户修改" :value="4"></el-option>
                        <el-option label="已完成" :value="5"></el-option>
                        <el-option label="已入账" :value="6"></el-option>
                    </el-select>
                    <el-select size="mini" v-model="formDatas.asrHandlerStatus" clearable @change="partserch"
                        placeholder="请选择发票识别状态" style="width: 130px">
                        <el-option label="待处理" :value="1"></el-option>
                        <el-option label="已处理" :value="2"></el-option>
                        <el-option label="处理失败" :value="3"></el-option>
                    </el-select>
                    <el-select size="mini" v-model="formDatas.asrCheckType" clearable @change="partserch"
                        placeholder="请选择识别状态" style="width: 130px">
                        <el-option label="系统" :value="0"></el-option>
                        <el-option label="人工" :value="1"></el-option>
                    </el-select>

                    <div class="filter-actions">
          <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="">搜索</el-button>
                    <el-button type="primary" size="mini" style=""
                        @click="bulkImport = true">批量导入已入账发票</el-button>
                    <el-button type="warning" size="mini" style="" @click="Out()"
                        >导出Exccel</el-button>
                    <el-button type="warning" size="mini" style="" @click="Out2()"
                        > 导出Exccel和发票文件</el-button>
                    <el-button type="success" size="mini" style="" @click="BulkDelete">发送通知</el-button>
                    <el-button type="primary" size="mini" style="" @click="BulkEditHandlerDate"
                        v-if="selectedRowKeysCollection.length > 0">批量修改处理时间</el-button>
                    <el-button type="success" size="mini" style=" " @click="BoxOpen">新增发票通知</el-button>
          </div>
        </el-row>
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input size="mini" v-model="formDatas.invoiceNum" placeholder="发票号码" style="width: 180px;"
                        clearable></el-input>
                    <el-input size="mini" v-model="formDatas.invoiceDate" placeholder="开票日期" style="width: 180px;"
                        clearable></el-input>
                    <!-- 处理开始时间 -->
                    <el-date-picker v-model="formDatas.checkHandlerDateStart" type="date" value-format="yyyy-MM-dd"
                        placeholder="处理开始时间" style="width: 140px" size="mini" clearable @change="partserch">
                    </el-date-picker>
                    <!-- 处理结束时间 -->
                    <el-date-picker v-model="formDatas.checkHandlerDateEnd" type="date" value-format="yyyy-MM-dd"
                        placeholder="处理结束时间" style="width: 140px" size="mini" clearable @change="partserch">
                    </el-date-picker>
                    <el-date-picker v-model="formDatas.fileDateStart" type="date" value-format="yyyy-MM-dd"
                        placeholder="上传日期开始" style="width: 140px" size="mini" clearable @change="partserch">
                    </el-date-picker>
                    <el-date-picker v-model="formDatas.fileDateEnd" type="date" value-format="yyyy-MM-dd"
                        placeholder="上传日期结束" style="width: 140px" size="mini" clearable @change="partserch">
                    </el-date-picker>
                </el-row>
        </div>
        <div class="tablemain" v-loading="tableLoading" element-loading-background="rgba(255, 255, 255, 0.9)" element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" custom-class="table-loading">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="asrId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑发票通知' : '新增发票通知'" :before-close="handleClose"
                :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                            <el-form-item label="商户名称" prop="asId">
                                <el-select v-model="form.asId" filterable clearable placeholder="请选择"
                                    style="width: 80%;">
                                    <el-option v-for="(item, index) in getAjefShopList_data" :key="index"
                                        :label="item.asName" :value="item.asId"></el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item label="归属年月" prop="asrYearMonth">
                                <el-date-picker v-model="form.asrYearMonth" type="month" value-format="yyyyMM"
                                    placeholder="请选择归属年月" style="width: 140px" clearable>
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="标题" prop="asrTitle">
                                <el-input v-model="form.asrTitle" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="开票金额" prop="asrMoney">
                                <el-input v-model="form.asrMoney" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="备注" prop="asrDes">
                                <el-input v-model="form.asrDes" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-drawer>
            <!-- 编辑发票信息 -->
            <el-dialog title="编辑发票信息" :visible.sync="invoiceEditDialog" width="70%"
                :before-close="invoiceEditDialogClose" :close-on-click-modal="false">
                <el-form ref="formRef2" :model="formIc" label-position="top" :rules="rules" style="height:100%">
                    <div
                        style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                        <el-form-item label="开票名称" prop="sellerName">
                            <el-input v-model="formIc.sellerName" style="width: 80%;" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="价税合计(小写)" prop="amountInFiguers">
                            <el-input v-model="formIc.amountInFiguers" style="width: 80%;" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="税率" prop="commodityTaxRate">
                            <el-input v-model="formIc.commodityTaxRate" style="width: 80%;"
                                placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="价税合计(大写)" prop="amountInWords">
                            <el-input v-model="formIc.amountInWords" style="width: 80%;" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="合计金额" prop="totalAmount">
                            <el-input v-model="formIc.totalAmount" style="width: 80%;" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="发票种类" prop="invoiceType">
                            <el-input v-model="formIc.invoiceType" style="width: 80%;" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="发票号码" prop="invoiceNum">
                            <el-input v-model="formIc.invoiceNum" style="width: 80%;" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="货物名称" prop="commodityName">
                            <el-input v-model="formIc.commodityName" style="width: 80%;" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="开票日期" prop="invoiceDate">
                            <el-input v-model="formIc.invoiceDate" style="width: 80%;" placeholder="请输入"></el-input>
                        </el-form-item>
                    </div>
                </el-form>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="invoiceEditDialogClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="invoiceEditSureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>

            </el-dialog>

            <!-- 批量导入 -->
            <el-dialog title="批量导入(只显示处理失败的信息)" :visible.sync="bulkImport" width="70%" :before-close="bulkImportClose"
                style="margin-left: 200px;">
                <div style="margin: 0 10px 10px;display: flex;">
                    <el-upload class="upload-demo" action="#" accept=".xlsx,.xls" :on-change="updatabulk"
                        :auto-upload="false" ref="bulk" multiple>
                        <el-button size=" medium" type="danger">点击上传</el-button>

                    </el-upload>
                    <div>
                        <el-button type="primary"
                            @click="downloadFile('https://trainapp.aojuai.com/assets/excel/invoiceEntry.xlsx', '发票入账标记模板')"
                            style="margin-left: 20%;height: 40px;">下载模板</el-button>
                    </div>
                </div>
                <div>
                    <ve-table :columns="columnsImport" :table-data="bulkData" :max-height="500" :border-x="true"
                        :border-y="true" :scrollWidth="10" row-key-field-name="dataIndex"
                        :cell-style-option="cellStyleOption" style="width: 100%"  :cellSelectionOption="cellSelectionOption" />
                    <div v-show="bulkData.length == 0" class="empty-data">暂无数据</div>
                </div>
            </el-dialog>
            <!-- 批量修改处理时间 -->
            <el-dialog title="批量修改处理时间" :visible.sync="isBulkDete" width="70%" :before-close="isBulkDeteClose"
                :close-on-click-modal="false">
                <el-form ref="formRef3" :model="formDate" label-position="top" :rules="rules" style="height:100%">
                    <div
                        style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                        <el-form-item label="处理时间" prop="checkHandlerDate">
                            <el-date-picker v-model="formDate.checkHandlerDate" type="date" value-format="yyyy-MM-dd"
                                placeholder="请选择处理时间" style="width: 240px" clearable>
                            </el-date-picker>
                        </el-form-item>
                    </div>
                </el-form>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="isBulkDeteClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="isBulkDeteSureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-dialog>
            <!-- 审核发票 -->
            <el-dialog title="审核发票" :visible.sync="isAudit" width="70%" :before-close="isAuditClose"
                :close-on-click-modal="false">
                <el-form ref="formRef4" :model="formAudit" label-position="top" :rules="rules" style="height:100%">
                    <div
                        style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                        <el-form-item label="审核备注" prop="checkDes">
                            <el-input v-model="formAudit.checkDes" style="width: 80%;" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="处理时间" prop="checkHandlerDate">
                            <el-date-picker v-model="formAudit.checkHandlerDate" type="date" value-format="yyyy-MM-dd"
                                placeholder="请选择处理时间" style="width: 240px" clearable>
                            </el-date-picker>
                        </el-form-item>
                    </div>
                </el-form>
                <div slot="footer" class="dialog-footer" style="margin-top: 10px;" v-if="formAudit.isType == 2">
                    <el-button @click="isAuditClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="danger" @click="handleRefuseCheck2" style="margin-left: 150px;">
                        确定驳回</el-button>
                </div>
                <div slot="footer" class="dialog-footer" style="margin-top: 10px;" v-else>
                    <el-button @click="isAuditClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="handleCheck" style="margin-left: 150px;">
                        通过审核</el-button>
                    <el-button type="danger" @click="handleRefuseCheck" style="margin-left: 150px;">
                        拒绝通过</el-button>
                </div>

            </el-dialog>
            <!-- 平台上传发票 -->
            <el-dialog title="平台上传发票" :visible.sync="isInvoiceUpload" width="70%" :before-close="isInvoiceUploadClose"
                :close-on-click-modal="false">
                <el-form ref="formRef5" :model="formUploadInvoice" label-position="top" :rules="rules"
                    style="height:100%">
                    <div
                        style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                        <el-form-item label="发票金额" prop="asrShopMoney">
                            <el-input v-model="formUploadInvoice.asrShopMoney" style="width: 80%;"
                                placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="商户填报日期">
                            <el-button type="primary" @click="addAsrShopYearMonth" size="mini"
                                style="margin-left: 10px;">添加</el-button>
                            <div v-for="(item, index) in asrShopYearMonth || []" :key="index">
                                <el-date-picker v-model="asrShopYearMonth[index]" type="month" value-format="yyyy-MM"
                                    placeholder="请选择商户填报日期" style="width: 180px" clearable>
                                </el-date-picker>
                                <el-button type="danger" @click="delAsrShopYearMonth(index)" size="mini"
                                    style="margin-left: 10px;">删除</el-button>
                            </div>
                        </el-form-item>
                        <el-form-item label="上传发票">
                            <my-uploadOnly ref="upload" @fileChange="fileChange" :filearr="fileList" :limit="1"
                                :multiple="false"
                                style="margin: 10px 5px 5px;" @removeAfter="removeAfter" type="text"></my-uploadOnly>
                        </el-form-item>
                    </div>
                </el-form>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="isInvoiceUploadClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="isInvoiceUploadSureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { calcTableHeight } from "../../utils/tableHeight.js";
let Base64 = require('js-base64').Base64
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import { updateAjefShopReceiptFiles, updateAjefShopReceiptStatusCheckRevoke, updateAjefShopReceiptStatusCheckMulti, uploadAjefShopReceiptInBill, getAjefShopListQuick, updateAjefShopReceiptStatusCheck, getAjefShopReceiptList, addAjefShopReceipt, updateAjefShop, updateAjefShopReceiptStatusSend, updateAjefShopReceipt } from "../../api/api";
import { del } from 'vue';
export default {
    name: "",
    components: {},
    data() {
        return {
            fileList: [],
            isInvoiceUpload: false,
            formUploadInvoice: {},
            asrShopYearMonth: [],
            isAudit: false,
            formAudit: {},
            isBulkDete: false,
            formDate: {},
            invoiceEditDialog: false,
            formIc: {},
            columnsImport: [{
                field: "",
                key: "a",
                title: "序号",
                width: 50,
                align: "center",
                fixed: 'left',
                renderBodyCell: ({ row, column, rowIndex }, h) => {
                    return ++rowIndex;
                },
            },
            {
                field: "des",
                key: "des",
                title: "状态",
                width: 150,
                align: "center",
                fixed: 'left',

            },
            {
                field: "invoiceCode",
                key: "invoiceCode",
                title: "发票代码",
                width: 150,
                align: "center",
            },
            {
                field: "invoiceNum",
                key: "invoiceNum",
                title: "发票号码",
                align: "center",
            },
            {
                field: "invoiceDate",
                key: "invoiceDate",
                title: "发票日期",
                align: "center",
            },
            {
                field: "invoiceTypeOrg",
                key: "invoiceTypeOrg",
                title: "发票名称",
                align: "center",
            },],
            getAjefShopList_data: [],
            theRow: {},
            form2: {},
            diaAddReturn: false,
            diaDetail: false,
            tableDataDetail: [],
            dialogStatusValue: '',
            dialogStatus: false,
            key: 'asrId',
            dialog: false,
            edit: false,
            form: {
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: false,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,

            columns: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",
                    fixed: 'left',
                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "asrYearMonth",
                    key: "asrYearMonth",
                    title: "所属日期",
                    align: "center",
                    fixed: 'left',
                    width: 100,
                },
                {
                    field: "asName",
                    key: "asName",
                    title: "商户名称",
                    align: "center",
                    width: 120,
                },
                {
                    field: "asNameOriginal",
                    key: "asNameOriginal",
                    title: "商户初始名称",
                    align: "center",
                    width: 120,
                },
                {
                    field: "asrTitle",
                    key: "asrTitle",
                    title: "标题",
                    align: "center",
                    width: 80,
                },

                {
                    field: "asrMoney",
                    key: "asrMoney",
                    title: "发票金额",
                    align: "center",
                    width: 100,
                },
                {
                    field: "asrShopMoney",
                    key: "asrShopMoney",
                    title: "商户填报金额",
                    align: "center",
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span style={{ color: row.asrShopMoney * 1 !== row.asrMoney * 1 ? 'red' : 'black' }} >{row.asrShopMoney}</span>
                        );
                    },
                },
                {
                    field: "asrShopYearMonth",
                    key: "asrShopYearMonth",
                    title: "商户填报日期",
                    align: "center",
                    width: 100,
                },
                {
                    field: "asrtReceiptTypeName",
                    key: "asrtReceiptTypeName",
                    title: "商户开票结算类型",
                    align: "center",
                    width: 200,
                },
                {
                    field: "asrFiles",
                    key: "asrFiles",
                    title: "商户上传发票",
                    align: "center",
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span style="display:flex;align-items: center;">
                                <div style="width:100%;">
                                    {
                                        row.asrFiles ? JSON.parse(row.asrFiles)[0].url.split(',').map((item => {
                                            const str = JSON.parse(row.asrFiles)[0].type == '1' ? <el-image ref="scrImg" id="scrimg" src={item} alt="" fit="scale-down" style="width: 50px;height: 50px;display: inline-block;"
                                                previewSrcList={[item]}></el-image> : <el-button
                                                    size="mini"
                                                    type="text"
                                                    style="vertical-align: middle;"
                                                    on-click={() => this.downloadFile(item, '发票文件.pdf')}
                                                >
                                                下载PDf
                                            </el-button>
                                            return str
                                        })) : ''
                                    }


                                </div>
                            </span>
                        );
                    },
                },
                {
                    field: "asrFilesTime",
                    key: "asrFilesTime",
                    title: "上传文件时间",
                    align: "center",
                    width: 180,
                },
                {
                    field: "sellerName",
                    key: "sellerName",
                    title: "开票名称",
                    align: "center",
                    edit: false,
                    width: 200,
                },
                {
                    field: "amountInFiguers",
                    key: "amountInFiguers",
                    title: "价税合计(小写)",
                    align: "center",
                    edit: false,
                    width: 140,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span style={{ color: row.amountInFiguers * 1 !== row.asrMoney * 1 ? 'red' : 'black' }} >{row.amountInFiguers}</span>
                        );
                    },
                },
                {
                    field: "commodityTaxRate",
                    key: "commodityTaxRate",
                    title: "税率",
                    align: "center",
                    edit: false,
                    width: 100,
                },
                {
                    field: "amountInWords",
                    key: "amountInWords",
                    title: "价税合计(大写)",
                    align: "center",
                    edit: false,
                    width: 190,
                },
                {
                    field: "totalAmount",
                    key: "totalAmount",
                    title: "合计金额",
                    align: "center",
                    edit: false,
                    width: 140,
                },
                {
                    field: "totalTax",
                    key: " totalTax",
                    title: "合计税额",
                    align: "center",
                    edit: false,
                    width: 140,
                },
                {
                    field: "invoiceType",
                    key: "invoiceType",
                    title: "发票种类",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "invoiceTypeOrg",
                    key: "invoiceTypeOrg",
                    title: "发票名称",
                    align: "center",
                    edit: false,
                    width: 190,
                },
                {
                    field: "invoiceCode",
                    key: "invoiceCode",
                    title: "发票代码",
                    align: "center",
                    edit: false,
                    width: 100,
                },
                {
                    field: "invoiceNum",
                    key: "invoiceNum",
                    title: "发票号码",
                    align: "center",
                    edit: false,
                    width: 190,
                },
                {
                    field: "purchaserName",
                    key: "purchaserName",
                    title: "发票台头",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "invoiceDate",
                    key: "invoiceDate",
                    title: "发票日期",
                    align: "center",
                    edit: false,
                    width: 190,
                },
                {
                    field: "commodityName",
                    key: "commodityName",
                    title: "货物名称",
                    align: "center",
                    edit: false,
                    width: 190,
                },


                {
                    field: "asrDes",
                    key: "asrDes",
                    title: "备注",
                    align: "center",
                    edit: false,
                    width: 160,
                },

                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },

                {
                    field: "checkusername",
                    key: "checkusername",
                    title: "审核人",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                {
                    field: "checkDes",
                    key: "checkDes",
                    title: "审核信息",
                    align: "center",
                    width: 130,
                },
                {
                    field: "amountInFiguersFinance",
                    key: "amountInFiguersFinance",
                    title: "价税合计财务",
                    align: "center",
                    width: 110,
                },
                {
                    field: "receiptTypeFinance",
                    key: "receiptTypeFinance",
                    title: "票种财务",
                    align: "center",
                    width: 90,
                },
                {
                    field: "checkHandlerDate",
                    key: "checkHandlerDate",
                    title: "处理时间",
                    align: "center",
                    edit: false,
                    fixed: 'right',
                    width: 120,
                },
                {
                    field: "asrStatus",
                    key: "asrStatus",
                    title: "状态",
                    align: "center",
                    fixed: 'right',
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.asrStatus == 1 ? <el-tag size="mini" >创建</el-tag> :
                                        row.asrStatus == 2 ? <el-tag size="mini" type="danger">待商户上传</el-tag> :
                                            row.asrStatus == 3 ? <el-tag size="success" size="mini">商户已上传</el-tag> :
                                                row.asrStatus == 4 ? <el-tag size="mini" type="danger">待商户修改</el-tag> : 
                                                row.asrStatus == 5 ? <el-tag size="mini" type="success">已完成</el-tag> : <el-tag type="info" size="mini">已入账</el-tag>
                                }
                            </span>
                        );
                    },
                },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 140,
                    align: "center",
                    fixed: "right",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.asrStatus == 3 ?
                                        <el-button
                                            size="mini" type="text" style="color:green" on-click={() => this.HandleAudit(row)} > 审核 </el-button> : <span></span>
                                }
                                {
                                    row.asrStatus == 5 ?
                                        <el-button
                                            size="mini" type="text" style="color:red" on-click={() => this.HandleAudit2(row)} > 驳回 </el-button> : <span></span>
                                }
                                {
                                    row.asrStatus == 2 || row.asrStatus == 4 ? <el-button
                                        size="mini"
                                        type="text"
                                        style="color: red"
                                        on-click={() => this.handleUploadInvoice(row)}
                                    >
                                        上传发票
                                    </el-button> : ''
                                }
                                {
                                    row.asrStatus == 1 ? <el-button
                                        size="mini"
                                        type="text"
                                        style="color: red"
                                        on-click={() => this.handleDelete(row)}
                                    >
                                        发送通知
                                    </el-button> : ''
                                }
                                {
                                    row.asrStatus !== 1 ? <el-button
                                        size="mini"
                                        type="text"
                                        on-click={() => this.invoiceEditDialogOpen(row)}
                                    >
                                        编辑发票信息
                                    </el-button> : ''
                                }

                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                dmDelete: 1,
                currentPage: 1,
                pageSize: 10,
            },
            bulkImport: false,
            bulkData: [],
            bulkDataCopy: [],
            sitId: '',
            importData: {},
            tableLoading: false,

        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = calcTableHeight(this, this.windheight, 140);
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = calcTableHeight(this, val, 140);
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = calcTableHeight(this, this.windheight, 140);
        getAjefShopListQuick({ pageSize: 0 }).then(res => {
            this.getAjefShopList_data = res.data
        })
        this.getList();
    },
    mounted() { },
    methods: {
        isInvoiceUploadClose() {
            this.isInvoiceUpload = false;
            this.formUploadInvoice = {};
            this.asrShopYearMonth = ['']
            this.fileList = []
            this.$refs.upload && this.$refs.upload.clearFiles()
            this.$refs.formRef5.resetFields();
        },
        handleUploadInvoice(row) {
            this.isInvoiceUpload = true;
            this.formUploadInvoice = JSON.parse(JSON.stringify(row));
            this.formUploadInvoice.asrId = row.asrId;
            this.formUploadInvoice.asrFiles = [];
            this.asrShopYearMonth = row.asrShopYearMonth ? row.asrShopYearMonth.split(',') : [''];
        },
        addAsrShopYearMonth() {
            this.asrShopYearMonth.push('')
        },
        delAsrShopYearMonth(index) {
            this.asrShopYearMonth.splice(index, 1)
        },
        isInvoiceUploadSureBtn() {
            //   是否确认上传   
            this.$confirm("是否确定上传发票, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    const newForm = JSON.parse(JSON.stringify(this.formUploadInvoice))
                    newForm.asrFiles = JSON.stringify(this.formUploadInvoice.asrFiles)
                    newForm.asrShopYearMonth = this.asrShopYearMonth.toString()
                    updateAjefShopReceiptFiles(newForm).then(res => {
                        if (res.status == 200) {
                            this.$message({
                                type: "success",
                                message: "上传成功!",
                            });
                            this.isInvoiceUploadClose();
                            this.getList();
                        }
                    })
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                });

        },
        fileChange(file) {
            // 上传发票只允许单张，直接覆盖赋值，避免重复 push 导致 asrFiles 累加
            const list = [];
            file.forEach((item, index) => {
                list.push({
                    type: 2,
                    url: item
                })
            })
            this.formUploadInvoice.asrFiles = list;
            console.log(file, this.formUploadInvoice.asrFiles);
            this.$message({
                type: "success",
                message: "上传成功!",
            });
        },
        removeAfter(file) {
            // 删除时同步清理上传发票表单中的对应记录（原误写成 this.form，导致删除无效）
            const url = this.formUploadInvoice.asrFiles.findIndex(item => item.url === file)
            if (url > -1) {
                this.formUploadInvoice.asrFiles.splice(url, 1)
            }
        },
        HandleAudit(row) {
            this.formAudit.asrId = row.asrId
            this.formAudit.isType = 1
            this.isAudit = true;
        },
        HandleAudit2(row) {
            this.formAudit.asrId = row.asrId;
            this.formAudit.isType = 2
            this.isAudit = true;
        },
        isAuditClose() {
            this.isAudit = false;
            this.formAudit = {};
            this.$refs.formRef4.resetFields();
        },
        BulkEditHandlerDate() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    message: "请选择要修改的数据",
                    type: "warning"
                });
                return
            }
            this.isBulkDete = true;
        },
        isBulkDeteClose() {
            this.isBulkDete = false;
            this.checkboxOption.selectedRowKeys = [];
            this.selectedRowKeysCollection = [];
            this.$refs.formRef3.resetFields();
        },
        isBulkDeteSureBtn() {
            //    是否确认编辑
            this.$confirm("是否确定吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    const asrIds = this.selectedRowKeysCollection.toString();
                    const checkHandlerDate = this.formDate.checkHandlerDate;
                    updateAjefShopReceiptStatusCheckMulti({ asrIds, checkHandlerDate }).then(res => {
                        if (res.status == 200) {
                            this.$message({
                                type: "success",
                                message: "修改成功!",
                            });
                            this.isBulkDeteClose();
                            this.getList();
                        }
                    })
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                });
        },
        invoiceEditDialogOpen(row) {
            this.formIc = JSON.parse(JSON.stringify(row));
            this.invoiceEditDialog = true
        },
        invoiceEditDialogClose() {
            this.invoiceEditDialog = false;
            this.$refs.formRef2.resetFields();
        },
        invoiceEditSureBtn() {
            //    是否确认编辑
            this.$confirm("是否确定吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjefShopReceipt(this.formIc).then(res => {
                        if (res.status == 200) {
                            this.$message({
                                type: "success",
                                message: "编辑成功!",
                            });
                            this.invoiceEditDialogClose();
                            this.getList();
                        }
                    })
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                });
        },
        Out() {
            const FormData = {
                ...this.formDatas,
                exportType: 1,
                asrIds: this.selectedRowKeysCollection.toString(),
            }
            var s = qs.stringify(FormData);
            this.openLoading()
            var that = this
            axios({
                method: 'post',
                url: config.baseURL + '/ajef-shop-receipt/exportAjefShopReceiptList',
                data: s,
                // withCredentials: true,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'useref': window.localStorage.getItem('Qy_token')
                }
            }).then(function (res) {
                if (res.data) {
                    that.loadings.close()
                    let a = document.createElement('a');
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/zip"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", '发票列表.zip');
                    a.click();
                    that.checkboxOption.selectedRowKeys = [];
                    that.selectedRowKeysCollection = [];
                    that.$message({
                        message: "成功",
                        type: "success"
                    });

                }
            })
        },
        Out2() {
            const FormData = {
                ...this.formDatas,
                exportType: 2,
                asrIds: this.selectedRowKeysCollection.toString(),
            }
            var s = qs.stringify(FormData);
            this.openLoading()
            var that = this
            axios({
                method: 'post',
                url: config.baseURL + '/ajef-shop-receipt/exportAjefShopReceiptList',
                data: s,
                // withCredentials: true,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'useref': window.localStorage.getItem('Qy_token')
                }
            }).then(function (res) {
                if (res.data) {
                    that.loadings.close()
                    let a = document.createElement('a');
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/zip"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", '发票列表.zip');
                    a.click();
                    that.checkboxOption.selectedRowKeys = [];
                    that.selectedRowKeysCollection = [];
                    that.$message({
                        message: "成功",
                        type: "success"
                    });

                }
            })
        },
        getAjefShopListChange(val) {
            console.log(val);
            this.getAjefShopList_data.forEach((item, index) => {
                if (item.asId == val) {
                    this.form.asrDes = item.asrtReceiptTypeName
                }
            })

        },
        downloadFile(url, name) {
            //下载
            if (!url) {
                return;
            }
            let link = document.createElement("a");
            link.style.display = "none";
            link.target = '_blank';
            link.href = url;
            link.onload = function () {
                document.body.removeChild(link);
            };
            link.setAttribute("download", name);
            document.body.appendChild(link);
            link.click();
        },
        Preview(url) {
            window.open('https://filepreview.aojuai.com/onlinePreview?url=' + encodeURIComponent(Base64.encode(url)));
        },
        handleCheck() {
            this.$confirm("是否确定通过审核吗?, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    const newForm = JSON.parse(JSON.stringify(this.formAudit))
                    newForm.asrIdPass = 2
                    updateAjefShopReceiptStatusCheck(newForm).then(res => {
                        this.$message({
                            type: "success",
                            message: "审核成功!",
                        });
                        this.isAuditClose()
                        this.partserch()
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleRefuseCheck() {
            this.$confirm("是否确定驳回审核吗?, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    const newForm = JSON.parse(JSON.stringify(this.formAudit))
                    newForm.asrIdPass = 1
                    updateAjefShopReceiptStatusCheck(newForm).then(res => {
                        this.$message({
                            type: "success",
                            message: "审核成功!",
                        });

                        this.isAuditClose()
                        this.partserch()
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleRefuseCheck2() {
            this.$confirm("是否确定驳回吗?, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    const newForm = JSON.parse(JSON.stringify(this.formAudit))
                    updateAjefShopReceiptStatusCheckRevoke(newForm).then(res => {
                        this.$message({
                            type: "success",
                            message: "审核成功!",
                        });

                        this.isAuditClose()
                        this.partserch()
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        bulkImportClick() {
            if (this.sitId == '') {
                this.$message({
                    showClose: true,
                    message: "请导入资料",
                    type: 'danger'
                });
            } else {
                uploadImportAjAssetsKey({
                    sitId: this.sitId
                }).then(res => {
                    this.getList()
                    this.bulkImport = false;
                    this.bulkData = [];
                    this.bulkDataCopy = [];
                    this.sitId = '';
                    this.$refs['bulk'].clearFiles()
                    this.$message({
                        type: 'success',
                        message: '导入成功!'
                    });
                })
            }

        },
        async updatabulk(file, fileList) {
            console.log(file, fileList);
            let Data = new FormData();
            Data.append('file', file.raw)
            this.openLoading()
            uploadAjefShopReceiptInBill(Data).then(res => {
                console.log("上传成功")
                this.loadings.close()
                this.bulkData = res.data;
                this.bulkDataCopy = res.data
            })
        },
        bulkImportClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                    this.bulkData = [];
                    this.bulkDataCopy = [];
                    this.$nextTick(() => {
                        this.getList()
                    })
                    this.$refs.bulk.clearFiles();
                })
                .catch(_ => { });
        },
        handleStatus(row) {
            this.theRow = row;
            this.dialogStatusValue = row.aakStatus;
            this.dialogStatus = true;
        },
        sureStatus() {
            updateAjAssetsFireEquipmentStatus({ asrId: this.theRow.asrId, aakStatus: this.dialogStatusValue }).then(res => {
                if (res.data) {
                    this.$message({
                        type: "success",
                        message: "修改成功!",
                    });
                    this.getList();
                    this.dialogStatusValue = ''
                }
            })
            this.dialogStatus = false;
        },
        closeStatus() {
            this.dialogStatus = false;
            this.dialogStatusValue = ''
        },
        // 批量删除
        BulkDelete() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.$confirm("是否确定吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateAjefShopReceiptStatusSend({ asrIds: this.selectedRowKeysCollection.toString() }).then(res => {
                            this.$message({
                                type: "success",
                                message: "成功!",
                            });
                            this.checkboxOption.selectedRowKeys = [];
                            this.selectedRowKeysCollection = [];
                            this.partserch()
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },
        handleDelete(row) {
            this.$confirm("是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjefShopReceiptStatusSend({ asrIds: row.asrId }).then(res => {
                        this.$message({
                            type: "success",
                            message: "成功!",
                        });

                        this.partserch()
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        const newForm = JSON.parse(JSON.stringify(this.form))
                        if (newForm.acrAmount == 0) {
                            newForm.acrAmount = newForm.acrAmount2
                        }
                        addAjefShopReceipt(newForm).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateAjefShop(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
        },

        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.asrId = row.asrId
                    console.log(jsonObj);
                    updateAjefShop(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = [...new Set(this.selectedRowKeysCollection.concat(selectedRowKeys))] || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            this.tableLoading = true;
            getAjefShopReceiptList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                this.tableLoading = false;
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            }).catch(() => {
                this.tableLoading = false;
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            this.tableLoading = true;
            getAjefShopReceiptList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                this.tableLoading = false;
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            }).catch(() => {
                this.tableLoading = false;
            });
        },
        getList() {
            this.tableLoading = true;
            getAjefShopReceiptList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.tableLoading = false;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>